export { useCollaboratorCatalogCourses } from './use-collaborator-catalog-courses';
